import { Editorial } from '@xo-union/tk-ui-typography';
import React from 'react';

import { PagesQuery } from '../../generated/graphql';
import HelpfulIdeaCard from '../HelpfulIdeaCard';
import RsvpGuidanceCard from '../RsvpPageCard/RsvpGuidanceCard';
import RegistryGuidanceCard from '../RegistryPageCard/RegistryGuidanceCard';
import registryInfo from '../../helpers/registryInfo';
import styles from './styles.scss';
import { useRegistrySummaryQuery } from '../../generated/graphql';
import {
  TRAVEL_PAGE_TYPE,
  THINGS_TO_DO_PAGE_TYPE,
  QA_PAGE_TYPE,
  STORY_PAGE_TYPE,
  PHOTO_PAGE_TYPE,
  WEDDING_PARTY_PAGE_TYPE,
} from '../../helpers/pages';

type Page = PagesQuery['pages'][0];

interface Props {
  pages: Page[];
  goToWorkflow: boolean;
}
interface IEmptyCardSection {
  title: string;
  pages: Page[];
  id?: string;
}

const helpGuestsPlanSet = new Set([TRAVEL_PAGE_TYPE, THINGS_TO_DO_PAGE_TYPE, QA_PAGE_TYPE]);
const addPersonalTouchSet = new Set([STORY_PAGE_TYPE, PHOTO_PAGE_TYPE, WEDDING_PARTY_PAGE_TYPE]);

const EmptyCardSection = ({ title, pages, id }: IEmptyCardSection) => (
  <>
    <Editorial id={id} className={styles.subSectionHeader}>
      {title}
    </Editorial>
    <div className={styles.cardContainer}>
      {pages.map(page => (
        <HelpfulIdeaCard key={`helpful-${page.id}`} page={page} />
      ))}
    </div>
  </>
);

const HelpfulIdeasSection: React.FC<Props> = ({ pages, goToWorkflow }) => {
  const { data } = useRegistrySummaryQuery();
  const { hasAnyRegistry } = registryInfo(data?.registrySummary);
  const helpGuestsPlanPages = pages.filter(page => helpGuestsPlanSet.has(page.type));
  const addPersonalTouchPages = pages.filter(page => addPersonalTouchSet.has(page.type));

  return (
    <div data-testid="add-to-your-site-section">
      {(!hasAnyRegistry || goToWorkflow) && (
        <>
          {goToWorkflow && <RsvpGuidanceCard />}
          {!hasAnyRegistry && <RegistryGuidanceCard />}
        </>
      )}
      {!!(addPersonalTouchPages.length || helpGuestsPlanPages.length) && (
        <div className={styles.helpfulIdeasSuggestions}>
          <Editorial id="helpful-ideas-suggestions-editorial" className={styles.subSectionHeader}>
            Suggested Pages
          </Editorial>
          <div className={styles.dividerLine} />
        </div>
      )}
      {!!addPersonalTouchPages.length && (
        <EmptyCardSection title="Add your personal touch:" pages={addPersonalTouchPages} />
      )}
      {!!helpGuestsPlanPages.length && <EmptyCardSection title="Help your guests plan:" pages={helpGuestsPlanPages} />}
    </div>
  );
};

export default HelpfulIdeasSection;
